import { push } from "connected-react-router";

App.Views.RouteSuggestion = {
    renderLayoutTab: function () {

      const label = 'Greenmile.RouteSuggestion.screenName';
      GreenmileReduxStore.dispatch({
        type: 'GREENMILE_TAB_ROUTE_SUGGESTION',
        payload: {
          key: 'RouteSuggestion',
          title: `${Monet.I18n.getResourcesByKey(label)}`
        }
      });
      GreenmileReduxStore.dispatch(push('/RouteSuggestion'));
    },

    showModalFilter: function (pendingOrder, selector, scopeBlock) {
      var routeSuggestion = new Greenmile.RouteSuggestion.PopupFilter();
      var callback = function () {
        return function (suggestions, pendingOrder) {
          routeSuggestion.closeModalWindow();

          Monet.Session.RouteSuggestion = {
            suggestions,
            pendingOrder
          };

          App.Views.RouteSuggestion.renderLayoutTab();

        };
      }();

      routeSuggestion.setPendingOrder(pendingOrder);
      routeSuggestion.callbackAfterFilter(callback);
      routeSuggestion.show({
        selector,
        scopeBlock,
        width: 500,
        height: 518
      });
    }
};
